$(function(){
  setTimeout(function(){
    brandFilter();
  },1000);
  setTimeout(function(){
    modalFilter();
  },1000);
  enableCollectionNext();

  $('.brand_toggle').toggleClass('active');
  $('.brand_toggle').next().slideToggle();

  disableSelection();
  initCustomIndexSlider();
})

mobileCollectionType = (evt) =>{
  var $this = $(evt);
  if ($(window).width() < 798) {
    $this.siblings('.mobile_type_container').slideToggle("slow");
    $this.children('.showText').toggle();
  }
}

directToCollectionMobile = (evt,url) =>{
  var $this = $(evt);
  location.href= url;
}

directToProduct = () =>{
  var $product_link = $('.hidden-product-link').attr('href');
  location.href = $product_link;
}

brandFilter = () =>{
  var $brand = $('.active.brand_filter');
  var $brandVal = $brand.attr('data-filte_val');
  var $modal_a = $('.model_filter');
  var $this_data_attr;
  $modal_a.each(function(){
   $this_data_attr = $(this).attr('data-filte_val');
    if ($this_data_attr.includes($brandVal)) {
      $(this).parent().show();
    }
  });
  // $('.model_toggle').click();
}

modalFilter = () =>{
  var $moadl = $('.active.model_filter');
  var $modalVal = $moadl.attr('data-filte_val');
  var $year_a = $('.year_filter');
  var $this_data_attr;
  $year_a.each(function(){
   $this_data_attr = $(this).attr('data-filte_val');
    if ($this_data_attr.includes($modalVal)) {
      $(this).parent().show();
    }
  });
}

brand_onclick = () =>{
  setTimeout(function(){
    brandFilter();
    $('.model_toggle').toggleClass('active');
    $('.model_toggle').next().slideToggle();
    $('.brand_toggle').toggleClass('active');
    $('.brand_toggle').next().slideToggle();
    disableSelection();
  },1500);
}

model_onclick = () =>{
  setTimeout(function(){
    modalFilter();
    $('.year_toggle').toggleClass('active');
    $('.year_toggle').next().slideToggle();
    $('.brand_toggle').toggleClass('active');
    $('.brand_toggle').next().slideToggle();
    $('.model_toggle').toggleClass('active');
    $('.model_toggle').next().slideToggle();
    disableSelection();
  },1500);
}

year_onclick = () =>{
  setTimeout(function(){
    enableCollectionNext();
    disableSelection();
    $('.year_toggle').toggleClass('active');
    $('.year_toggle').next().slideToggle();
    $('.brand_toggle').toggleClass('active');
    $('.brand_toggle').next().slideToggle();
    $('.model_toggle').toggleClass('active');
    $('.model_toggle').next().slideToggle();
  },1500);
}

customClearFilter = (x) =>{
  if (x.includes('brand')) {
    $('.clear-active-filter.model_clear').click();
  } else if (x.includes('model')) {
    setTimeout(function(){
      brandFilter();
    },1500);
    $('.clear-active-filter.year_clear').click();
  } else if (x.includes('year')) {
    setTimeout(function(){
      modalFilter();
    },1500);
    enableCollectionNext();
  }
  setTimeout(function(){
    disableSelection();
  },1500);
}

enableCollectionNext = () =>{
  var $isSelected = $('.year_clear').hasClass('clear-active-filter');

  if ($isSelected) {
    $('#nextToProduct_btn').removeAttr('disabled');
  } else {
    $('#nextToProduct_btn').attr('disabled');
  }
}

desktopCollectionType = (evt) =>{
  var $this = $(evt);
  var $selected_type = $this.attr('data-collection_type');
  var $type_container = $('.desktop_type_container');

  $this.siblings().removeClass('active-collection');
  $this.addClass('active-collection');

  $type_container.hide();
  $type_container.each(function(){
    var $_type = $(this).attr('data-collection_type');
    if ($selected_type == $_type) {
      $(this).show();
    }
  });
}

directToCollection = (evt) =>{
  var $this = $(evt);
  var $sellected_url = $this.siblings('.active-collection').attr('data-type_url');

  location.href = $sellected_url;
}

disableSelection = () =>{
  var $isBrand = $('.brand_toggle').next().children('.filter-active-tag').find('input').val();

  var $isModel = $('.model_toggle').next().children('.filter-active-tag').find('input').val();

  if ($isBrand == undefined) {
    $('.model_toggle').click(false);
  } else {
    $('.model_toggle').attr('style','cursor: pointer !important; background: #173F6D;');
  }

  if ($isModel == undefined) {
    $('.year_toggle').click(false);
  } else {
    $('.year_toggle').attr('style','cursor: pointer !important; background: #173F6D;');
  }
}

initCustomIndexSlider = () =>{
  $('.customHomeSlider').flickity({
    wrapAround: true
  });
}
